// @ts-nocheck
import { Column } from 'react-table'
import { PurchasedProductInfoCell } from './PurchasedProductInfoCell'
import { PurchasedProductActionsCell } from './PurchasedProductActionsCell'
import { PurchasedProductSelectionCell } from './PurchasedProductSelectionCell'
import { PurchasedProductCustomHeader } from './PurchasedProductCustomHeader'
import { PurchasedProductSelectionHeader } from './PurchasedProductSelectionHeader'
import { PurchasedProduct } from '../../core/_models'
import { FormattedMessage } from 'react-intl'

const purchasedproductsColumns: ReadonlyArray<Column<PurchasedProduct>> = [
  {
    Header: (props) => <PurchasedProductSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <PurchasedProductSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <PurchasedProductCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PURCHASEDPRODUCT.TABLE.COLUMN.SUPPLIER' defaultMessage='Supplier' />}
        className='min-w-125px'
      />
    ),
    id: 'supplier_name',
    accessor: 'supplier.supplier_name',
  },
  {
    Header: (props) => (
      <PurchasedProductCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PURCHASEDPRODUCT.TABLE.COLUMN.PRODUCTNAME' defaultMessage='Product Name' />}
        className='min-w-125px'
      />
    ),
    id: 'product_name',
    accessor: 'product_name',
  },
  {
    Header: (props) => (
      <PurchasedProductCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PURCHASEDPRODUCT.TABLE.COLUMN.QUANTITY' defaultMessage='Quantity' />}
        className='min-w-100px'
      />
    ),
    id: 'quantity',
    accessor: 'quantity',
  },
  {
    Header: (props) => (
      <PurchasedProductCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PURCHASEDPRODUCT.TABLE.COLUMN.PURCHASEPRICE' defaultMessage='Purchase Price' />}
        className='min-w-125px'
      />
    ),
    id: 'purchase_price',
    accessor: 'purchase_price',
  },
  {
    Header: (props) => (
      <PurchasedProductCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PURCHASEDPRODUCT.TABLE.COLUMN.PURCHASEDATE' defaultMessage='Purchase Date' />}
        className='min-w-125px'
      />
    ),
    id: 'purchase_date',
    accessor: 'purchase_date',
  },
  {
    Header: (props) => (
      <PurchasedProductCustomHeader
        tableProps={props}
        title={<FormattedMessage id='PURCHASEDPRODUCT.TABLE.COLUMN.SERVICE' defaultMessage='Service' />}
        className='min-w-150px'
      />
    ),
    id: 'service_info',
    Cell: ({ row }) => {
      const service = row.original.service;
      const serviceInfo = service
        ? `${service.service_category?.category_name || 'N/A'} (${service.company?.company_name || 'N/A'})`
        : 'N/A';
      return <span>{serviceInfo}</span>;
    },
  },
  {
    Header: (props) => (
      <PurchasedProductCustomHeader
        tableProps={props}
        title={<FormattedMessage id='TABLE.GENERAL.ACTION' defaultMessage='Actions' />}
        className='text-end min-w-100px'
      />
    ),
    id: 'actions',
    Cell: ({ ...props }) => <PurchasedProductActionsCell id={props.data[props.row.index].id} />,
  },
];

export { purchasedproductsColumns };
